<template>
    <div class="bar bg_fff">
        <v-title title="在线咨询数量"></v-title>
        <div class="main">
            <v-chart :options="options"></v-chart>
        </div>
    </div>
</template>

<script>
  import {timeFormat} from "../../lib/utils";
  import VTitle from "../common/v-title";

  export default {
    name: 'home-consult-total',
    data() {
      return {
        options: {
          tooltip: {
            trigger: 'axis'
          },
          color: ['#2FC25B', '#1890FF'],
          grid: {
            top: 30,
            bottom: 30,
            left: '5%',
            right: 30
          },
          legend: {
            right: 30,
            data: ['图文咨询', '视频咨询']
          },
          xAxis: {
            type: 'category',
            data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
          },
          yAxis: {
            type: 'value'
          },
          series: []
        }
      }
    },
    computed: {},
    components: {VTitle},
    mixins: [],
    created() {
    },
    mounted() {
      setTimeout(this.getData, 2000);
    },
    beforeDestroy() {

    },
    methods: {
      getData() {
        const now = Date.now();
        let cate = [], data1 = [], data2 = [];
        for (let i = 0; i < 15; i++) {
          cate.push(timeFormat(now + i * 24 * 3600 * 1000, '%m-%d'));
          data1.push(Math.round(Math.random() * 100));
          data2.push(Math.round(Math.random() * 100));
        }
        this.options.xAxis.data = cate;
        this.options.series = [{
          data: data1,
          type: 'line',
          name: '图文咨询'
        }, {
          data: data2,
          type: 'line',
          name: '视频咨询'
        }];
      }
    }
  }
</script>

<style scoped>
    .main {
        height: 200px;
    }

    .main >>> .echarts {
        width: 100%;
        height: 100%;
    }
</style>
